import { Component } from '@angular/core';
import { ArticleInvoice } from '../../models/article-invoice';

@Component({
  selector: 'app-invoice-article',
  imports: [],
  templateUrl: './invoice-article.component.html',
  styleUrl: './invoice-article.component.scss'
})
export class InvoiceArticleComponent {
 articles!: ArticleInvoice[];
}
